var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-seat"},[_c('div',{staticClass:"empty-img flexdc"},[_c('img',{attrs:{"src":require("../assets/empty.png")}}),_vm._t("default",function(){return [_c('span',[_vm._v("请选择查询的班级或学员")])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }